import { extractDigitsFromString } from './functions'

export const TITLE = 'Wingo Chat'
export const KC_INFO = '_KC_INFO'
export const UPDATE_USER = '_UPDATE_USER'
export const NOTIFICATION_SOUND = '_NOTIFICATION_SOUND'

export const MASKS = {
  PHONE_WITH_DDI: ['+55 (99) 9999-9999'],
  PHONE_EXTENDED_WITH_DDI: ['+55 (99) 99999-9999'],
  COMBINED_PHONE_WITH_DDI: (value: string) => {
    const onlyNumbers = extractDigitsFromString(value)
    const isCellPhoneExtended = onlyNumbers.length === 11
    return onlyNumbers?.length <= 10 && !isCellPhoneExtended ? MASKS.PHONE_WITH_DDI : MASKS.PHONE_EXTENDED_WITH_DDI
  }
}

export const SETUP_APP_ID = import.meta.env.VITE_APP_WINGO_SETUP_APP_ID
export const SETUP_CONFIG_ID = import.meta.env.VITE_APP_WINGO_SETUP_CONFIG_ID
export const HTTP_STATUS = { OK: 'OK', BAD_REQUEST: 'BAD_REQUEST', UNAUTHORIZED: 'AUTHORIZED' }

export const BROADCAST = {
  DESELECT_CHAT: {
    name: 'deselectChat'
  }
}
